import React from 'react';
import { useTranslation } from 'react-i18next';
import { DATADOG_PRIVACY_LEVELS } from 'constants/enums';

const PaymentSummary = (props) => {
  const { t } = useTranslation();

  const { payment } = props;

  const creditCardPayment = () => (
    <>
      <p>{t('checkout.summary.payment.payWithCard')}</p>
      <p data-dd-privacy={DATADOG_PRIVACY_LEVELS.MASK}>
        {t('checkout.summary.payment.cardInfo', {
          brand: payment.brand,
          last4: payment.last4,
        })}
      </p>
    </>
  );

  const cashPayment = () => (
    <>
      <p>{t('checkout.summary.payment.cashAppPay')}</p>
      <p data-dd-privacy={DATADOG_PRIVACY_LEVELS.MASK}>{payment.cashtag}</p>
    </>
  );

  return (
    <>
      <h3>{t('checkout.summary.payment.title')}</h3>
      {payment.cashtag ? cashPayment() : creditCardPayment()}
    </>
  );
};

export default PaymentSummary;
